<template>
    <div class="body">
        <div class="search-container">
            <div class="search-box">
                <div class="input-box">
                    <span class="title">手机号：</span>
                    <el-input class="input" size="medium" v-model="content"  placeholder="输入手机号"></el-input>
                </div>
                <div class="input-box">
                    <span class="title">手机号：</span>
                    <el-input class="input" size="medium" v-model="content"  placeholder="输入手机号"></el-input>
                </div>
                <div class="input-box">
                    <span class="title">手机号：</span>
                    <el-input class="input" size="medium" v-model="content"  placeholder="输入手机号"></el-input>
                </div>

                <div class="input-other-box" v-show="isShowOther">
                    <div class="input-box">
                        <span class="title">手机号：</span>
                        <el-input class="input" size="medium" v-model="content"  placeholder="输入手机号"></el-input>
                    </div>
                    <div class="input-box">
                        <span class="title">手机号：</span>
                        <el-input class="input" size="medium" v-model="content"  placeholder="输入手机号"></el-input>
                    </div>
                    <div class="input-box">
                        <span class="title">手机号：</span>
                        <el-select v-model="value" placeholder="请选择" size="medium">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="btn-box">
                <el-button class="primary-btn">重置</el-button>
                <el-button type="primary">查询</el-button>
                <el-button style="background-color: white;border: none" @click="showOther()">
                    展开
                    <i v-show="isShowOther === false" class="el-icon-arrow-down el-icon--right"></i>
                    <i v-show="isShowOther" class="el-icon-arrow-up el-icon--right"></i>
                </el-button>
            </div>
        </div>

        <div class="table-box">
            <div class="table-btn">
                <el-button type="primary" icon="el-icon-plus">增加教师</el-button>
            </div>
            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        fixed
                        prop="date"
                        label="日期"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="姓名"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="province"
                        label="省份"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="city"
                        label="市区"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="地址"
                        >
                </el-table-column>
                <el-table-column
                        prop="zip"
                        label="邮编"
                        >
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="240">
                    <template slot-scope="scope">
                        <div class="handle-btn">
                            <el-button class="primary-btn">编辑</el-button>
                            <el-button type="danger">删除</el-button>
                            <el-button type="text">下载资源</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TemplatePage',
        data() {
            return {
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }, {
                    value: '选项3',
                    label: '蚵仔煎'
                }, {
                    value: '选项4',
                    label: '龙须面'
                }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],
                value: '',
                content:'',
                isShowOther:false,
                tableData: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1517 弄',
                    zip: 200333
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1519 弄',
                    zip: 200333
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1516 弄',
                    zip: 200333
                }]
            }
        },
        methods:{
            showOther(){
                this.isShowOther = !this.isShowOther
            }
        }
    };
</script>

<style lang="scss" scoped>
    $radius:4px;
    .body{
        height: 100vh;
    }
    .search-container{
        margin-top: 10px;
        padding: 16px;
        border-radius: $radius;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        .search-box{
            width: 80%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .input-box{
                margin-top: 6px;
                margin-bottom: 6px;
                margin-right: 26px;
                .input{
                    width: 230px;
                }
                .title{
                    font-size:9px;
                    color:#343434;
                }
                select{
                    width: 230px;
                }
            }

            .input-other-box{
                /*margin-top: 10px;*/
                display: flex;
                align-items: center;
                flex-wrap: wrap;


            }
        }
        .btn-box{
            width: 20%;
        }
    }

    .table-box{
        button{
            margin: 22px 0;
        }
        background-color: #ffffff;
        margin-top: 20px;
        padding-bottom: 58px;
        padding-left: 22px;
        padding-right: 22px;
        overflow-y:auto;
        border-radius: $radius;

    }
    .handle-btn{
        display: flex;
        align-items: center;
        button{
            margin: 4px;
        }

    }
    .primary-btn{
        border-color: #409EFF;
        color: #409EFF;
    }


</style>
